import { render, staticRenderFns } from "./SO.vue?vue&type=template&id=607b7f6c&scoped=true"
import script from "./SO.vue?vue&type=script&lang=js"
export * from "./SO.vue?vue&type=script&lang=js"
import style0 from "./SO.vue?vue&type=style&index=0&id=607b7f6c&prod&lang=css"
import style1 from "./SO.vue?vue&type=style&index=1&id=607b7f6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607b7f6c",
  null
  
)

export default component.exports